import './tooltip.css';
import React, { Component } from 'react';
import ReactTooltip from 'react-tooltip';

class Tooltip extends Component {
  render() {
    const {
      description,
      id,
    } = this.props;
    return (
      <div className="toolTipSection">
        <div data-for={id} data-tip={description}>
          <img alt="questionCircle" src="question-circle.svg" />
        </div>
        <ReactTooltip className="tooltip"
          effect="solid"
          id={id}
          place="right"
        />
      </div>
    );
  }
}

export default Tooltip;
